import { createFileRoute, redirect } from "@tanstack/react-router";
import { MOVED_TO_CATALOGUE, tabSearch } from "@/app/tabs";
import { PendingSurface } from "@/components/feedback/pending-surface";
import { requirePerm } from "@/lib/auth/guards";

export const Route = createFileRoute("/_authenticated/inventory")({
  // Retired `?tab=` ids resolve to the tab that absorbed them — `app/tabs.ts`.
  validateSearch: tabSearch("inventory"),
  beforeLoad: ({ search, context }) => {
    // THE THREE IDS THAT LEFT THE SHELF ARE FORWARDED, NOT DRAWN.
    //
    // An alias resolves an old id to a tab this surface still has; `products`,
    // `pricing` and `formulary` name a screen that is `/catalogue`'s now. They
    // reach here as themselves — `resolveTab` passes an id it does not know
    // through on purpose, so a module's tab is not refused before the module
    // exists — and Inventory's answer to an id it does not draw is its own
    // first tab. So without this, `?tab=pricing` renders the shelf: a link that
    // silently went somewhere else, on a screen that looks perfectly fine.
    //
    // `replace`, because an old address is not a step in anybody's history —
    // Back should leave for wherever they actually came from.
    //
    // IT CARRIES THE TAB AND NOTHING ELSE, BECAUSE THERE IS NOTHING ELSE YET.
    // The POC's rule is that the hop carries the query — `?item=AG400C` is the
    // whole of what such a link was written for. This surface's
    // `validateSearch` models `tab` alone, so zod has already stripped anything
    // else before `beforeLoad` sees it. When the real screen arrives and models
    // `item`, this must forward it; a redirect that quietly drops the product a
    // link named is the dead end the redirect exists to avoid. `PORT-LOG.md`.
    //
    // BEFORE THE PERMISSION CHECK, and it costs nothing today: both surfaces
    // are behind `VIEW_INVENTORY` (see `app/nav.ts`), so a reader who may not
    // open the shelf may not open the catalogue either and meets the same
    // refusal one address along. Were the two rights ever to part, this order
    // would have to reverse — a redirect that outruns a guard is how a door
    // gets opened by being pointed at the room behind it.
    const moved = search.tab === undefined ? undefined : MOVED_TO_CATALOGUE[search.tab];
    if (moved) throw redirect({ to: "/catalogue", search: { tab: moved }, replace: true });
    requirePerm("VIEW_INVENTORY")({ context });
  },
  component: () => <PendingSurface titleKey="nav.inventory" />,
});
